var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/social/pinterest-share.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<svg viewBox=\"0 0 95 95\" class=\"c-social__pinterest\" xmlns=\"http://www.w3.org/2000/svg\">\n    <title>";
output += runtime.suppressValue((lineno = 1, colno = 13, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["social-pinterest"])), env.opts.autoescape);
output += "</title>\n    <path d=\"M47.5 0C21.3 0 0 21.3 0 47.5S21.3 95 47.5 95 95 73.7 95 47.5 73.7 0 47.5 0zm3.8 58.6c-3.1 0-6-1.7-7-3.6 0 0-1.6 6.6-2 7.9-1.3 4.5-4.9 9-5.2 9.4-.2.2-.7.1-.7-.2-.1-.6-1-6.3.1-10.9.6-2.3 3.7-15.6 3.7-15.6s-.9-1.8-.9-4.5c0-4.2 2.4-7.4 5.5-7.4 2.6 0 3.9 2 3.9 4.3 0 2.6-1.6 6.5-2.5 10.1-.7 3 1.5 5.5 4.5 5.5 5.4 0 9.1-7 9.2-15.2 0-6.3-4.2-11-11.9-11-8.7 0-14.1 6.5-14.1 13.7 0 2.5.7 4.2 1.9 5.6.5.6.6.9.4 1.6-.2.5-.5 1.8-.6 2.3-.2.7-.7 1-1.4.7-4-1.6-5.9-6-5.9-10.9 0-8.2 6.8-17.9 20.4-17.9 10.9 0 18.1 7.9 18 16.5 0 11.2-6.2 19.6-15.4 19.6z\"></path>\n</svg>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/social/pinterest-share.j2"] , dependencies)